/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import translate from 'services/i18n/translate';
import { RailBackgroundImageName } from '../../../types/components/ColdStart';

interface Props {
  bemModifier: string | number;
  coldStartText?: string;
  coldStartTitle?: string;
  railBackgroundImageName?: RailBackgroundImageName;
  requiresPrivacyConsent?: boolean;
  onClickPrivacyConcentOptIn?: () => void;
}

export default function ColdStartLarge({
  bemModifier,
  coldStartText,
  coldStartTitle,
  railBackgroundImageName,
  requiresPrivacyConsent,
  onClickPrivacyConcentOptIn,
}: Props): JSX.Element {
  const showPrivacyConsentInfo = requiresPrivacyConsent;

  return (
    <div className="content-card-cell large" id={`ColdStartCard___${bemModifier}`}>
      <a
        className={`context-switch content-card large double-line filling-content-card others ${railBackgroundImageName} ${
          railBackgroundImageName ? '' : 'noBackgroundImage'
        }`}
      >
        <div className="border-radius-container card-wrapper">
          <div className="content-card-image">
            {!showPrivacyConsentInfo ? (
              <span className="ftu-title" id={`ColdStartCard_title___${bemModifier}`}>
                {coldStartTitle}
              </span>
            ) : null}
            <span
              className="ftu-subtitle"
              style={{ whiteSpace: showPrivacyConsentInfo ? 'pre-wrap' : undefined }}
              id={`ColdStartCard_text___${bemModifier}`}
            >
              {!showPrivacyConsentInfo ? coldStartText : translate['firstTimeUse.recommendations.optIn.invite']}
            </span>
          </div>

          <div className="content-card-info">
            {showPrivacyConsentInfo ? (
              <span
                className="ftu-button cursor-pointer"
                onClick={onClickPrivacyConcentOptIn}
                id={`ColdStartCard_button___${bemModifier}`}
              >
                {translate['firstTimeUse.recommendations.optIn.button']}
              </span>
            ) : null}
          </div>
        </div>
      </a>
    </div>
  );
}
